export const name = "ARRAY_TO_STRING";
export const summary = `Produces a concatenation of the elements in an array as a \`STRING\` value.`;
export const reference = `
## ARRAY_TO_STRING

Produces a concatenation of the elements in an array as a \`STRING\` value.

\`\`\`
ARRAY_TO_STRING(array_expression, delimiter[, null_text])
\`\`\`

### Description

Returns a concatenation of the elements in \`array_expression\`as a \`STRING\`. The value for \`array_expression\`can either be an array of \`STRING\` or\`BYTES\` data types.

If the \`null_text\` parameter is used, the function replaces any \`NULL\` values in the array with the value of \`null_text\`.

If the \`null_text\` parameter isn't used, the function omits the \`NULL\` value and its preceding delimiter.


### Return type

\`STRING\`


### Examples



\`\`\`
SELECT ARRAY_TO_STRING(['coffee', 'tea', 'milk', NULL], '--', 'MISSING') AS text

/*--------------------------------*
 | text |
 +--------------------------------+
 | coffee--tea--milk--MISSING |
 *--------------------------------*/
\`\`\`



\`\`\`
SELECT ARRAY_TO_STRING(['cake', 'pie', NULL], '--', 'MISSING') AS text

/*--------------------------------*
 | text |
 +--------------------------------+
 | cake--pie--MISSING |
 *--------------------------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/array_functions
`;
